var exports = {
  "G": "RVZ2ekV",
  "z": "VGRobm5",
};

module.exports = exports;
